module.exports = __webpack_public_path__ + "img/snow.f61c81fd.png";